import React, { useState, useRef } from "react";
import * as FeatherIcon from "react-feather";
import { Overlay } from "react-bootstrap";
import DomainChip from "./DomainChip";
import ParsedTextWithLinks from "./ParsedTextWithLinks";
import { formatBoldText } from "../../services/commonService";

const InfoTooltipIcon = ({ payload, from = "" }) => {
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const hideTimer = useRef(null);

  const displayedSection = [
    "Insight Summary Profile Market Position",
    "By Technology",
    "By Application",
    "By Geography",
    "Market Share Analysis",
    "Customer Segment Analysis",
    "Key Expansions & Strategic Initiatives",
  ];

  const open = (e) => {
    if (hideTimer.current) clearTimeout(hideTimer.current);
    setTarget(e.currentTarget);
    setShow(true);
  };

  const scheduleClose = () => {
    if (hideTimer.current) clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setShow(false), 180);
  };

  // --- Helper: normalize sources ---
  const parseSources = (source) => {
    if (!source) return [];

    // Split on common delimiters
    // const parts = source
    //   .split(/[,;|]+/)
    //   .map((s) => s.trim())
    //   .filter(Boolean);
    let parts = [];

    if (typeof source === "string") {
      // If `source` is a string, split by commas, semicolons, or pipes
      parts = source
        .split(/[,;|]+/)
        .map((s) => s.trim())
        .filter(Boolean);
    } else if (Array.isArray(source)) {
      // If `source` is an array, convert array elements to strings, split and process each one
      parts = source
        .map((item) => String(item)) // Ensure each item is a string
        .join(",") // Join into a single string
        .split(/[,;|]+/)
        .map((s) => s.trim())
        .filter(Boolean);
    } else if (source && typeof source === "object") {
      // If `source` is an object, convert it to a string by JSON.stringify and process
      parts = JSON.stringify(source)
        .split(/[,;|]+/)
        .map((s) => s.trim())
        .filter(Boolean);
    } else {
      // Handle any other cases (null, undefined, etc.)
      console.error("Invalid source type:", source);
    }

    return parts;
  };

  const isValidUrl = (str) => {
    try {
      new URL(str);
      return true;
    } catch {
      return false;
    }
  };

  const sources = parseSources(payload?.source);

  return (
    <>
      <span
        className="info-btn"
        onMouseEnter={open}
        onMouseLeave={scheduleClose}
        aria-label="More info"
      >
        <FeatherIcon.Info
          className="fa"
          style={{ width: "12px", height: "12px" }}
        />
      </span>

      <Overlay target={target} show={show} placement="top">
        {({ ...props }) => (
          <div
            {...props}
            className="custom-tooltip metric-tooltip"
            style={{ position: "absolute", ...props.style }}
            onMouseEnter={() => {
              if (hideTimer.current) clearTimeout(hideTimer.current);
            }}
            onMouseLeave={scheduleClose}
          >
            <div className="d-flex align-items-start justify-content-between">
              {!displayedSection.includes(from) && (
                <div>
                  <strong>Source:</strong>
                </div>
              )}

              {payload?.confidence_score && (
                <div>
                  <strong>Confidence:</strong>{" "}
                  <span
                    className={
                      payload?.confidence_score >= 0.88
                        ? "confidence high"
                        : payload?.confidence_score >= 0.8
                        ? "confidence medium"
                        : "confidence low"
                    }
                    style={{ fontWeight: "bold", border: "none" }}
                  >
                    {payload?.confidence_score >= 0.88
                      ? "High"
                      : payload?.confidence_score >= 0.8
                      ? "Medium"
                      : "Low"}
                  </span>
                </div>
              )}
            </div>

            {/* <div style={{ marginLeft: "-5px" }}>
              <DomainChip url={payload?.source ?? "—"} />
            </div> */}

            {/* Render multiple chips or plain text */}
            {!displayedSection.includes(from) && (
              <div style={{ marginLeft: "-5px" }}>
                {sources.length > 0 ? (
                  sources.map(
                    (src, idx) => (
                      <span className="d-inline-block">
                        <ParsedTextWithLinks text={src} />
                      </span>
                    )
                    // isValidUrl(src) ? (
                    //   <DomainChip key={idx} url={src} />
                    // ) : (
                    //   <span
                    //     key={idx}
                    //     className="plain-source"
                    //     style={{ marginLeft: "5px" }}
                    //   >
                    //     {src}
                    //   </span>
                    // )
                  )
                ) : (
                  // <span className="plain-source">—</span>
                  <span className="plain-source" style={{ marginLeft: "5px" }}>
                    Multiple publicly available sources
                  </span>
                )}
              </div>
            )}

            {payload?.reasoning && (
              <>
                {((!displayedSection.includes(from) && payload?.source) ||
                  payload?.confidence_score) && (
                  <hr style={{ margin: "6px 0" }} />
                )}
                <div style={{ whiteSpace: "pre-wrap" }}>
                  <strong>Methodology:</strong>{" "}
                  {formatBoldText(
                    <div style={{ marginLeft: "-5px" }}>
                      <ParsedTextWithLinks text={payload.reasoning} />
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        )}
      </Overlay>
    </>
  );
};

export default InfoTooltipIcon;
